<template>
  <div>
        <div class="block-content">
        

        <form class="form-horizontal" action="base_forms_premade.html" method="post" onsubmit="return false;">
            <h3 class="font-w300 push-10">{{ sectionLabelCreateNewPicture[actualLanguage] }}</h3>
          
            

            <div v-if="flagSaveNewPicture" class="form-group">
                <h5 class="push">{{ textDescription[actualLanguage] }}</h5>

                <div class="col-xs-12 col-md-4">
                    <label for="register4-firstname">{{ textBoxLabelPictureReferenceName[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="referenceName" placeholder="Refeference name">
                </div>

                <div class="col-sm-12 col-md-3">
                <label  for="example-multiple-select">{{ labelFileType[actualLanguage] }}</label>
                <select class="form-control" v-model=fileType size="1">
                    <option value="jpg">JPEG</option>
                    <option value="png">PNG</option>
                    <option value="bmp">BMP</option>
                </select>
              </div>  

                <div class="col-sm-12 col-md-4">
                    <p><button @click="createNewPicture()" type="button" class="btn btn-md btn-success" name="button">
                      <span><i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonCreatePicture[actualLanguage] }}</span></button></p>
                </div>  
            </div>
            <div v-else class="form-group">
              <div class="col-xs-12 col-md-12">
                <h4 class="push">{{ textPictureCreated[actualLanguage] }}</h4>
                <h5 class="push">{{ messageTransmitFile[actualLanguage] }}</h5>
                <h5 class="push">{{ newFileName }}</h5>
              </div>
              
            </div>

            <div class="col-xs-12"><hr></hr></div>

            <div v-if="pictureList.length > 0" class="row push">
              
              <div class="form-group">
                <div v-if="overlayParameters.pictureType==='channel'" class="col-xs-12">
                    <h5 >{{ labelTableChannel[actualLanguage] }}</h5>
                </div>
                <div v-if="overlayParameters.pictureType==='device'" class="col-xs-12">
                    <h5 >{{ labelTableDevice[actualLanguage] }}</h5>
                </div>
              </div>

              <div class="table-responsive">
                  <table class="table table-striped table-vcenter">
                      <thead>
                          <tr>
                              <th style="width: 50%;">Nom reference / Reference Name</th>
                              <th style="width: 50%;">Nom fichier / Filename</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for= "Picture in pictureList">
                              <td class="font-w600">{{Picture.pictureReferenceName}}</td>
                              <td>{{Picture.fileName}}</td>
                          </tr>
                      </tbody>
                  </table>
              </div>
            </div>



          </form>
        </div>

  </div>
</template>

<script>

import {mapState, mapActions} from 'vuex'
import Spinner from '../../components/Spinner.vue'
import _ from 'underscore'
export default {
  name: 'AddDeviceTemplateForm',
  components: {
    Spinner
  },
  data() {
    return {
      errorMsg: '',
      templateIsCreating: false,
      actualLanguage : "FR",
      flagSaveNewPicture : true,

      labelFileType:{FR: "Type de fichier", EN: 'File type'},
      fileType : "jpg",

      sectionLabelCreateNewPicture:{FR: "Enregistrement d'image au système", EN: 'System picture saving'},
      textDescription:{FR: "Pour configurer une image affiché dans la plateforme EV Sens, il faut que cette image soit au préalable enregistrée dans le système avec un identifiant spécifique. Le nom de fichier a transmettre est automatiquement créé par le système.",
                       EN: 'To configure an image displayed in the EV Sens platform, this image must first be registered in the system with a specific identifier. The file name to be transmitted is automatically created by the system.'},


      textBoxLabelPictureReferenceName:{FR: "Nom de référence de l'image", EN: 'Picture reference name'},
      referenceName : "",

      messageTransmitFile:{FR: "Nommer votre fichier image avec le nom suivant et le transmettre par courriel à support@evsens.ca",
                           EN: 'Rename your picture file with the following file name and transmit your file by email to support@evsens.ca'},
      newFileName : "",

      buttonCreatePicture :{FR: "Créer l'image", EN: 'Create picture'}, 

      labelTableChannel :{FR: "Images d'appareil enregistrés dans le système", EN: 'Device picture saved in the system'},
      labelTableDevice :{FR: "Images d'appareil de mesure enregistrés dans le système", EN: 'Measurement device picture saved in the system'},
      pictureList : [],

      textPictureCreated :{FR: "Le lien de l'image est créé dans le système", EN: 'The picture link is created in the system'}, 



    }
  },

  methods: {


    createNewPicture(){

      if(this.referenceName.length > 0){
          var requestData = { 'postAction':'CreateOrganizationPicture',
                              'organizationId': this.overlayParameters.organizationId,
                              'referenceName':this.referenceName,
                              'pictureType': this.overlayParameters.pictureType,
                              'fileType': this.fileType,
                            }

          this.$store.dispatch('sessionStore/postOrganization', requestData)
              .then((response) => {
                //console.log('----Save new picture-----')
                //console.log(response.data)
                
              if(response.data.Code=='OK'){
                  this.flagSaveNewPicture = false
                  this.newFileName = response.data.FileName
                  this.getPictureList()
                  }
                  else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
              })
      }
      else{
        var ErrorMessage = {FR:"Le nom de référence ne doit pas etre vide!",EN:"The reference name must not be empty!"}
        window.alert(ErrorMessage[this.actualLanguage])
      }

    },


    getPictureList(){
      this.pictureList = []
        var requestData = { 'postAction':'GetOrganizationPictureList',
                            'organizationId': this.overlayParameters.organizationId,
                            'pictureType': this.overlayParameters.pictureType,
                          }

        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
              //console.log('----Get Picture List-----')
              //console.log(response.data)
              
            if(response.data.Code=='OK'){
                this.pictureList = response.data.PictureList
                }
                else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
            })  

    },


  
  },

  computed: {
    ...mapState('sessionStore', ['profileData']),
    ...mapState('overlayStore', ['overlayParameters']),
  },

  mounted() {
    
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    this.getPictureList()


  }


}
</script>



// WEBPACK FOOTER //
// OrganizationApiAddPictureForm.vue?9f27f294